import React from 'react';

import Checkmark from '../../images/icons/checkmark.svg';

let defaultStepList = [
  'Create Account',
  'Select Payment Method',
  'Add an Address'
];

const Steps = ({ stepList, current }) => {
  stepList = stepList || defaultStepList;
  let stepCount = stepList.length;
  let steps = [], i;
  current = current ? parseInt(current, 10) : 1;

  for (i = 0; i < stepCount; i++) {
    let className = 'step step-' + (i + 1);
    if ((i + 1) === current) {
      className += ' current';
    } else if ((i + 1) < current) {
      className += ' done';
    } else {
      className += ' future';
    }

    if (i > 0) {
      steps.push(
        <span key={`steps-separator-${i}`} className="separator"><hr /></span>
      );
    }

    steps.push(
      <span key={'steps-item-' + i} className={className}>
        <span className="step-number">{i+1}</span>
        <span className="step-done"><img role="presentation" src={Checkmark} /></span>
        <span>{stepList[i]}</span>
      </span>
    );
  }

  return <div className="checkout-steps">{steps}</div>;
};

export default Steps;



/** WEBPACK FOOTER **
 ** ./src/views/checkout/Steps.js
 **/